// extracted by mini-css-extract-plugin
module.exports = {"myFinance":"Finance_myFinance__2kLOE","wrapper":"Finance_wrapper__dZ2NY"};